<template>
  <div
    class="tw:flex tw:flex-nowrap"
    data-testid="social-insight-widget"
  >
    <div class="tw:mr-0.5 tw:pt-0.5">
      <QIcon
        class="text-ds-denim-9"
        :name="icon"
        size="20px"
      />
    </div>

    <div class="tw:text-xxs">
      {{ title }}

      <div class="tw:text-left tw:text-xxs tw:font-bold">{{ value }}</div>
    </div>

    <BaseStreemTooltip>
      <slot name="tooltip" />
    </BaseStreemTooltip>
  </div>
</template>

<script setup lang="ts">
import { BaseStreemTooltip } from "shared/components/base";

export interface SocialInsightWidgetProps {
  icon: string;
  title: string;
  value: string;
}

defineProps<SocialInsightWidgetProps>();
</script>
